import { render, staticRenderFns } from "./AttendanceSideBar.vue?vue&type=template&id=54ae1e54"
import script from "./AttendanceSideBar.ts?vue&type=script&lang=ts&external"
export * from "./AttendanceSideBar.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports